import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { useData } from "../context/DataContext";
import { resolveImageUrl } from "./ImageUpload";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const { settings } = useData();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const logo = resolveImageUrl(settings?.logo);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-10">
        <div className="text-center mb-8">
          {logo ? (
            <img src={logo} alt="L'Élan Danse" className="h-24 mx-auto object-contain" />
          ) : (
            <div className="flex flex-col leading-none items-center">
              <span className="font-script text-5xl text-deep-rose">L&apos;élan</span>
              <span className="font-script text-4xl text-deep-rose -mt-1">Danse</span>
            </div>
          )}
          <p className="mt-3 text-xs uppercase tracking-widest text-stone-500 font-serif-display">Espace administrateur</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block text-sm uppercase tracking-widest text-stone-500 font-serif-display mb-2">Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="w-full bg-cream rounded-xl border border-blush-light px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blush" />
          </div>
          <div>
            <label className="block text-sm uppercase tracking-widest text-stone-500 font-serif-display mb-2">Mot de passe</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="w-full bg-cream rounded-xl border border-blush-light px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blush" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-coral text-white py-3 rounded-full font-serif-display tracking-widest uppercase text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50">
            {loading ? "Connexion..." : (<><LogIn size={16}/> Se connecter</>)}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
